<template lang="pug">
FetchErrorTransition(:isFetching="isFetching" :error="error")
  .main-warning(v-if="!resources")
    h1 Warning
    p Schedule rules can not be created because there are no resources. Please create at least one resources first.
  .main-warning(v-else-if="!startOfDay")
    h1 Warning
    p Schedule rules can not be created because the start of day has not yet been configured. Please configure the start of day in settings first.
  UpsertScheduleItem(
    v-else
    :scheduleItem="scheduleItem"
    :resources="resources"
    :isSaving="isSaving"
    :userCanViewAuditTrail="userCanViewAuditTrail"
    :startOfDay="startOfDay"
    @save="save"
    @cancel="cancel"
    )
</template>

<script>
import ScheduleItem from './ScheduleItem.js'
import UpsertScheduleItem from './UpsertScheduleItem.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'UpsertScheduleItemWrapper',
  components: { UpsertScheduleItem },
  props: { scheduleItemKey: String, userCanViewAuditTrail: Boolean }, // todo: refactor userCanViewAuditTrail to vuex
  data() {
    return {
      scheduleItem: null,
      resources: null,
      isFetching: false,
      error: null,
      isSaving: false,
    }
  },
  computed: {
    ...mapGetters('briqState', ['businessUnitStartOfDayTime']),
    startOfDay() {
      return this.businessUnitStartOfDayTime
    },
    title() {
      return this.key ? 'Edit item' : 'Create item'
    },
  },
  methods: {
    async save(scheduleItem) {
      try {
        this.isSaving = true
        await this.$apiClient.post('schedule/upsert', scheduleItem)
        this.$notifySuccess('Schedule rule saved')
        this.$setLocationPath('schedule')
      } catch (error) {
        this.$handleError({ error })
      }
      this.isSaving = false
    },
    cancel() {
      this.$setLocationPath('schedule')
    },
  },
  async beforeMount() {
    const promises = [this.$apiClient.get('resources').then(r => (this.resources = r.data))]
    if (this.scheduleItemKey) {
      promises.push(
        this.$apiClient
          .get(`/schedule/${this.scheduleItemKey}`)
          .then(r => (this.scheduleItem = new ScheduleItem(r.data))),
      )
    } else this.scheduleItem = new ScheduleItem()
    this.isFetching = true
    try {
      await Promise.all(promises)
    } catch (error) {
      this.error = error
      this.$handleError({ error })
    }
    this.isFetching = false
  },
}
</script>

<style lang="stylus">
.main-warning
  margin-top 3rem
  display flex
  flex-direction column
  align-items center

  h1
    font-size 1.5rem
</style>
